(() => {
  const opensAt = Date.parse('2026-10-11T00:00:00+01:00');
  const closesAt = Date.parse('2026-10-15T00:00:00+01:00');
  if (window.location.hostname.toLowerCase() === 'rsvp.onesquarebetter.com') {
    window.location.replace('https://www.onesquarebetter.com/pages/friends-and-family?view=rsvp-wednesday');
    return;
  }
  const isOpen = () => Date.now() >= opensAt && Date.now() < closesAt;
  const route = () => {
    document.querySelectorAll('[data-osb-secret-entrance]').forEach((link) => {
      if (!link.dataset.osbOriginalRsvpHref) link.dataset.osbOriginalRsvpHref = link.getAttribute('href');
      const original = link.dataset.osbOriginalRsvpHref;
      const url = new URL(original, window.location.origin);
      if (isOpen()) url.searchParams.set('view', 'rsvp-wednesday');
      link.setAttribute('href', isOpen() ? url.pathname + url.search : original);
    });
    if (isOpen() && window.location.pathname.replace(/\/$/, '') === '/pages/friends-and-family') {
      const url = new URL(window.location.href);
      if (url.searchParams.get('view') !== 'rsvp-wednesday') {
        url.searchParams.set('view', 'rsvp-wednesday');
        window.location.replace(url.toString());
      }
    }
  };
  route();
  document.addEventListener('shopify:section:load', route);
  window.addEventListener('pageshow', route);
  document.addEventListener('visibilitychange', route);
  document.addEventListener('pointerdown', route, true);
  document.addEventListener('keydown', route, true);
  window.setInterval(route, 1000);
})();
